<template>
  <div class="tips">
    <div class="mb_4">温馨提示:</div>
    <p>在本活动页面下载游戏，即可领取奖励哦！</p>
    <p>该活动创角奖励与盒子内其余活动创角奖励不共享</p>
  </div>
</template>

<script>
export default {
  data () {
    return {}
  },
}
</script>

<style scoped lang="scss">
.tips {
  width: calc(100vw - 24px);
  margin: 0 auto;
  padding: 8px;
  font-size: 13px;
  color: #FFED87;
  background-image: url('https://static.hzwxbz3.cn/Lianyun/font_end/wxhd/328/tips.png');
  background-size: 100% 100%;
  p {
    text-indent: 1em;
    line-height: 16px;
  }
}
</style>